module.exports = __webpack_public_path__ + "img/msd-ewm.e415d41f.jpg";